import { Text } from '@grupoboticario/flora-react';
import React from 'react';
import { IProduct } from 'src/common/types/CatalogType';

interface IProductName extends Pick<IProduct, 'name'> {} //NOSONAR

const ProductName = ({ name }: IProductName) => {
  return (
    <Text
      size="bodyLargeStandard"
      css={{ marginTop: '$4', fontFamily: '$primary' }}
    >
      {name}
    </Text>
  );
};

export default ProductName;
